"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _time = require("../../../helpers/time/time");

const Duration = ({
  duration
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: "duration"
}, Number.isFinite(duration) && (0, _time.durationFormat)(duration / 1000));

Duration.propTypes = {
  duration: _propTypes.default.number
};
Duration.defaultProps = {
  duration: undefined
};
var _default = Duration;
exports.default = _default;